import React from 'react';
import UpperCaseTextInput from "./UpperCaseTextInput";

const TextInputForm = ({
    onChange,
    value,
    name,
    onBlur,
    error,
    placeholder,
    readOnly,
    type = "text",
    style,
    maxLength,
    autoUppercase = true,
}) => {
    return (
        <UpperCaseTextInput
            onChange={onChange}
            value={value}
            name={name}
            onBlur={onBlur}
            error={error}
            className="form_control"
            placeholder={placeholder}
            readOnly={readOnly}
            TYPE={type}
            style={style}
            maxLength={maxLength}
            autoUppercase={autoUppercase}
        />
    );
}

export default TextInputForm;
